import React, { useState, useRef, Suspense } from "react";
import ReactPlayer from "react-player";

const SearchVideo = ({ videoUrl, elapsedSeconds }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 }); // x = left offset, y = bottom offset
  const [dragging, setDragging] = useState(false);
  const [rel, setRel] = useState({ x: 0, y: 0 });
  const playerRef = useRef(null);

  const handleReady = () => {
    if (playerRef.current && elapsedSeconds !== undefined) {
      // playerRef.current.seekTo(elapsedSeconds);
      playerRef.current.currentTime = elapsedSeconds;
    }
  };

  // --- Mouse drag handlers ---
  const onMouseDown = (e) => {
    setDragging(true);
    setRel({
      x: e.pageX - position.x,
      y: window.innerHeight - e.pageY - position.y,
    });
    e.preventDefault();
    e.stopPropagation();
  };

  const onMouseUp = () => setDragging(false);

  const onMouseMove = (e) => {
    if (!dragging) return;
    setPosition({
      x: e.pageX - rel.x,
      y: window.innerHeight - e.pageY - rel.y,
    });
    e.preventDefault();
    e.stopPropagation();
  };

  // --- Touch drag handlers ---
  const onTouchStart = (e) => {
    const touch = e.touches[0];
    setDragging(true);
    setRel({
      x: touch.pageX - position.x,
      y: window.innerHeight - touch.pageY - position.y,
    });
    e.preventDefault();
    e.stopPropagation();
  };

  const onTouchMove = (e) => {
    if (!dragging) return;
    const touch = e.touches[0];
    setPosition({
      x: touch.pageX - rel.x,
      y: window.innerHeight - touch.pageY - rel.y,
    });
    e.preventDefault();
    e.stopPropagation();
  };

  const onTouchEnd = () => setDragging(false);

  return (
    <div
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseUp}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      style={{
        position: "absolute",
        left: `${position.x}px`, // anchored to left
        bottom: `${position.y}px`, // anchored to bottom
        cursor: dragging ? "grabbing" : "grab",
        zIndex: 9999,
      }}
    >
      <div className="aspect-video h-[180px] 2xl:h-[260px]">
        <Suspense fallback={<div className="w-full h-full bg-black" />}>
          <ReactPlayer
            ref={playerRef}
            src={videoUrl}
            width="100%"
            height="100%"
            controls
            onReady={handleReady}
          />
        </Suspense>
      </div>
    </div>
  );
};

export default SearchVideo;
